var path = 'app/scripts/modules/amazon/src/serverGroup/configure/wizard/capacity/capacity.html';
var html = "<div class=\"clearfix\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <aws-server-group-capacity-selector command=\"command\"></aws-server-group-capacity-selector>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <aws-target-healthy-percentage-selector command=\"command\"></aws-target-healthy-percentage-selector>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/amazon/src/serverGroup/configure/wizard/capacity/capacity.html
// module id = 1239
// module chunks = 0